export enum ShipmentItemState {
  SHIPMENT_ITEM_EXISTS = 'ITEM_EXISTS',
  SHIPMENT_ITEM_DOES_NOT_EXIST = 'ITEM_DOES_NOT_EXIST',
  SHIPMENT_ITEM_IS_NOT_VALID = 'ITEM_IS_NOT_VALID',
  SHIPMENT_ITEM_REVIEW = 'ITEM_REVIEW',
  SHIPMENT_ITEM_STOLEN = 'ITEM_STOLEN',
  SHIPMENT_ITEM_SOLD = 'ITEM_SOLD'
}
